export default operator => {
  switch (operator) {
    case '==':
      return (left, right) => left === right;
    case '!=':
      return (left, right) => left !== right;
    case '<':
      return (left, right) => left < right;
    case '>':
      return (left, right) => left > right;
    default:
      throw new Error("Operator ".concat(operator, " cannot be found"));
  }
};